import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { timeout, map } from "rxjs/operators";

const mainUrl = environment.url;

@Injectable({
  providedIn: "root",
})
export class GeneratorService {
  constructor(private http: HttpClient) {}

  getAllGeneratorsPaged(page, size): Observable<any> {
    return this.http.get(mainUrl + `generator/paged?page=${page}&size=${size}`).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  getAllGenerators(): Observable<any> {
    return this.http.get(mainUrl + `generator`).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  getAllGeneratorsTwo(id): Observable<any> {
    return this.http.get(mainUrl + `generator/${id}/all`).pipe(
      timeout(30000),
      map((res: any) => res)
    );
  }

  getGeneratorById(id): Observable<any> {
    return this.http.get(mainUrl + `generator/${id}`).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  createGenerator(form): Observable<any> {
    return this.http.post(mainUrl + "generator", form).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  editGenerator(form, id): Observable<any> {
    return this.http.put(mainUrl + `generator/${id}`, form).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  validateGenerator(id: number): Observable<any> {
    return this.http.get(mainUrl + `generator/${id}/validate-ofac`).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  getAllUsersByGeneratorPaged(id, page, size): Observable<any> {
    return this.http.get(mainUrl + `generator/users/paged/${id}?page=${page}&size=${size}`).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  getAllUsersByGenerator(id): Observable<any> {
    return this.http.get(mainUrl + `generator/users/${id}`).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  deleteGenerator(id): Observable<any> {
    return this.http.delete(mainUrl + `generator/${id}`).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  getHeader() {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: window.localStorage.getItem("token"),
    });

    return headers;
  }

  getGeneratorReport(): Observable<any> {
    return this.http.post(mainUrl + `generator/report`, {}, { reportProgress: true, observe: "response", responseType: "blob" }).pipe(
      timeout(30000),
      map((res: any) => res.body)
    );
  }
}
